import SectionShell from "components/Section-Shell";

const Privacy = () => (
  <SectionShell heading="Privacy Policy">
    <div>
      <p className="py-1 my-1">
        Jedi Insights Private Limited (referred to as InsightJedi hereinafter)
        is a company incorporated in India. This privacy policy governs the
        collection and use of your personal information by us. This Product
        Privacy Policy does not apply to any information or data collected by
        InsightJedi as a controller for other purposes, such as information
        collected on our websites or through other channels for marketing
        purposes. If you have a question regarding our Privacy Policy, please
        contact us at info@insightjedi.com.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">
        What Information We Collect From You
      </p>
      <p className="py-1 my-1">
        We collect different types of personal information, depending on the way
        you use our website:
      </p>
      <ul>
        <p className="py-1 my-1">
          1. When you sign up for a free subscription and become a member of our
          website, we will ask you to provide us with certain personal
          information in order to create your account and enable you to use our
          website. This information may include, for example, your name, email
          address, job description, and the reason you chose to use our website.
        </p>
        <p className="py-1 my-1">
          2. When you decide to purchase a subscription, we will require your
          payment and billing details in order to process your purchase. This is
          in addition to the personal information we normally require as part of
          the sign-up process.
        </p>
        <p className="py-1 my-1">
          3. If you subscribed to our services via a 3rd party provider (e.g.,
          your Google account) we may also receive some personal information
          from that provider. Please refer to the specific provider's privacy
          policy in order to better understand what type of personal information
          the provider shares with us.
        </p>
      </ul>
      <p className="py-1 my-1">
        We also collect some inferred data which is generated when you log in to
        our website (either as a free or paid subscriber). This includes, for
        example, your IP address, the type of device you use to log in to our
        website, your browser type, and operating system.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">
        How Long Do We Keep this Information?
      </p>
      <p className="py-1 my-1">
        We keep your personal information for as long as you continue to be a
        subscribed user on our website, and until you indicate that you no
        longer wish to continue to use our website.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">
        What Do We Use This Information For?
      </p>
      <p className="py-1 my-1">
        The information we collect will only be used in the following ways:
      </p>
      <ul>
        <p className="py-1 my-1">
          1. To process transactions: The main reason we ask for the
          above-mentioned personal information is in order to process the
          transaction conducted with you; i.e. to provide you with the purchased
          product or the service that you requested from us.
        </p>
        <p className="py-1 my-1">
          2. To improve our website: We continuously strive to improve the
          InsightJedi website features based on the information and feedback we
          receive from you, including relevant solution pages, showcase pages,
          etc.
        </p>
        <p className="py-1 my-1">
          3. To send you information and updates if, upon registration with us,
          you explicitly approved our sending periodic emails to the email
          address you provided us with. These emails will contain information
          and updates pertaining to your subscription, occasional news related
          to the InsightJedi and updates regarding related products or offers.
        </p>
      </ul>
      <p className="py-1 my-1">
        Even if you consented to receiving our periodic emails, you can at any
        time opt out of receiving these emails by emailing us at
        info@insightjedi.com
      </p>
    </div>
    <div>
      <p className="text-center font-bold">Personalization</p>
      <p className="py-1 my-1">
        We do not use personal information to personalize the site for you
      </p>
    </div>
    <div>
      <p className="text-center font-bold">
        How Do We Protect Your Information?
      </p>
      <p className="py-1 my-1">
        We implement a variety of security measures to maintain the safety of
        your personal information when you enter or submit any personal details
        to InsightJedi.
      </p>
      <p className="py-1 my-1">
        InsightJedi uses secure servers. All sensitive information, including
        credit card details, is transmitted via Secure Socket Layer (SSL)
        technology, and then encrypted into our payment gateway provider's
        database, which is only accessible to those authorized with special
        access to each system. These personnel are required by law to keep
        confidential all information on our systems.
      </p>
      <p className="py-1 my-1">
        In addition, after any transaction, your credit card details and
        financial information are immediately deleted from our servers.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">Do we use cookies?</p>
      <p className="py-1 my-1">We do not use any cookies.</p>
      <p className="py-1 my-1">
        However, we use a variety of service providers for offering you better
        service:
      </p>
      <ul>
        <li>Google Analytics</li>
        <li>Firebase/Google Authentication</li>
        <li>Hubspot</li>
        <li>Sentry</li>
      </ul>
      <p className="py-1 my-1">
        Such third party service providers' cookies, may be placed on your
        browser when you log in to our website. Such providers can then analyze
        the data included in such cookies to provide us with valuable insights.
        Please refer to the specific provider's privacy policy in order to
        better understand how they store and use cookies.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">
        Do We Disclose Any of Your Personal Information to Outside Parties?
      </p>
      <p className="py-1 my-1">
        <b>Third Party Providers</b>
      </p>
      <p className="py-1 my-1">
        We are assisted by trusted third parties to operate our website, to
        conduct our business, and to provide you with our services. Such third
        party providers include billing companies, website infrastructure
        management, code management, error reporting, customer engagement, help
        desk, universal login service providers. As part of the provision of
        their services to us, we may transfer some of your personal information
        to them, inasmuch as such personal information is necessary for them to
        perform such service. For example: your credit card details will be
        analyzed through our billing software which is provided by a third party
        in order for us to provide you with an invoice when you make a purchase
        on our website.
      </p>
      <p className="py-1 my-1">
        <b>Other Forms of Disclosure</b>
      </p>
      <p className="py-1 my-1">
        In certain circumstances, we may also disclose your personal information
        to outside parties. This could happen if:
      </p>
      <ul>
        <p className="py-1 my-1">
          1. We believe that, under the specific circumstances, releasing such
          personal information will be appropriate in order to comply with any
          European Union or Member State law applicable to us;
        </p>
        <p className="py-1 my-1">
          2. We want to protect our legitimate interest and in order to do so we
          would need to disclose your personal information, and only after we
          made sure that we cannot protect our interest without disclosing your
          personal information;
        </p>
        <p className="py-1 my-1">
          3. We need to protect your or another individual’s vital interests.
        </p>
      </ul>
      <p className="py-1 my-1">
        No personal information will ever be provided to outside parties for
        marketing, advertising, or other such uses without your consent, or
        where we are obliged to disclose such information by law.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">Changes to This Privacy Policy</p>
      <p className="py-1 my-1">
        This privacy policy was last modified on Mar 27, 2020. If we update this
        privacy policy in a manner which changes how we collect or use your
        personal information, the types of personal information we collect or
        use, or the purposes for such collection or use of personal
        information,we will ask you to provide your consent to the new changes
        when you next log in to our website.
      </p>
    </div>
    <div>
      <p className="text-center font-bold">Your Rights</p>
      <p className="py-1 my-1">
        <b>Right to Lodge a Complaint</b>
      </p>
      <p className="py-1 my-1">
        If you believe that your right to data protection and privacy has been
        infringed by us in any way, you may contact the relevant supervisory
        authority in your place of residence.
      </p>
      <p className="py-1 my-1">
        <b>Right to Access</b>
      </p>
      <p className="py-1 my-1">
        You may ask for a copy of your personal information held by us. If you
        wish to do so, please contact us at info@InsightJedi.com and we shall
        provide you with an electronic copy of your personal information as soon
        as practicable and after we are able to verify the validity of your
        request and your identity. We will not be able to provide you with such
        access if this would adversely affect the rights and freedoms of others,
        or where the collation and presentation of such data would involve
        disproportionate cost to InsightJedi.
      </p>
      <p className="py-1 my-1">
        Should you require any additional copies, we may charge you a fee which
        shall not exceed the cost for generating copies.
      </p>
      <p className="py-1 my-1">
        Based on your request, we shall also provide you with the following
        information:
      </p>
      <ul>
        <p className="py-1 my-1">1. The types of personal data concerned;</p>
        <p className="py-1 my-1">
          2. The entities or individuals with whom we shared your personal
          information and whether they are located in countries outside of the
          European Union;
        </p>
        <p className="py-1 my-1">
          3. The duration of time we keep your personal information. If that is
          not possible, the criteria used to determine such a period.
        </p>
      </ul>
      <p className="py-1 my-1">
        <b>Right to Be Forgotten/Erasure</b>
      </p>
      <p className="py-1 my-1">
        If you decide that you no longer wish to be a member of our website and
        would like us to delete all of your personal information, please contact
        us at info@insightjedi.com
      </p>
      <p className="py-1 my-1">
        We will not be able to delete your personal information if it is
        required:
      </p>
      <ul>
        <p className="py-1 my-1">
          1. For the fulfillment of any contractual obligations we may have to
          you;
        </p>
        <p className="py-1 my-1">
          2. For the exercise of the right to freedom of expression and
          information;
        </p>
        <p className="py-1 my-1">
          3. In order to comply with a legal obligation required from us by
          European Union law or the law of the Member State of the European
          Union in which we operate;
        </p>
        <p className="py-1 my-1">4. For reasons of public interest;</p>
        <p className="py-1 my-1">
          5. For the establishment, exercise or defense of a legal claim.
        </p>
      </ul>
      <p className="py-1 my-1">
        Please be advised that following such deletion we will not be able to
        provide you with our services, and should you wish to rejoin our website
        you will need to complete a new registration process.
      </p>
      <p className="py-1 my-1">
        <b>Right to Rectification</b>
      </p>
      <p className="py-1 my-1">
        At any time during your usage of our platform, you may review, amend, or
        update the information you provided us with by logging in to the
        platform and accessing your account and profile settings.
      </p>
      <p className="py-1 my-1">
        <b>Right to Data Portability</b>
      </p>
      <p className="py-1 my-1">
        You have the right to ask us to provide a copy of your personal
        information to another provider, in the event that you wish to move your
        account to them.
      </p>
      <p className="py-1 my-1">
        If you wish to have such a copy, please contact us at
        info@insightjedi.com and we shall provide it to you in an electronic and
        machine readable form so that you may transmit such information to
        another entity.
      </p>
      <p className="py-1 my-1">
        If it is technically feasible and should you wish, we will transfer such
        information directly to such another entity at your request.
      </p>
      <p className="py-1 my-1">
        Please be advised that we will not be able to provide you with such a
        copy or transfer such information to such an entity if it would
        adversely affect the rights and freedoms of others.
      </p>
    </div>
  </SectionShell>
);

export default Privacy;
